import { z } from "zod"

export enum MissionProvider {
    DjiAPI = "DJI Cloud",
    AutelAPI = "Autel Cloud",
    SkydioAPI = "Skydio Cloud",
    NovaWebApp = "Nova",
    Aircast = "Aircast",
    Manual = "Manual",
}

export enum SyncStatus {
    Syncing = "syncing",
    Synced = "synced",
    Error = "error",
}

export const isValidMissionProvider = (provider: MissionProvider) =>
    z.enum(MissionProvider).safeParse(provider).success
